// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".encryption-field .encryption-error[data-v-646dd2fa] {\n  display: block;\n  color: #d93025;\n  font-size: 12px;\n  overflow-wrap: anywhere;\n}", ""]);
// Exports
module.exports = exports;
